import React, { memo } from "react";
import { Box, Typography } from "@mui/material";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend,);

interface DonutDataset {
  label: string;
  data: number[];
  backgroundColor?: string[];
}

interface GenericDonutChartProps {
  title: string;
  labels: string[];
  datasets: DonutDataset[];
  height?: number | string;
  options?: any;
}

const GenericDonutChart: React.FC<GenericDonutChartProps> = ({
  title,
  labels,
  datasets,
  height = 300,
  options,
}) => {
  const hasData = datasets.some(
    (ds) => ds.data.length > 0 && ds.data.some((v) => v !== 0)
  );

  if (!hasData) {
    return (
      <Box
        sx={{
          bgcolor: "#fff",
          borderRadius: 2,
          p: 1,
          boxShadow: 1,
          textAlign: "center",
        }}
      >
        <Typography
          fontWeight={600}
          mb={1}
          sx={{ textDecoration: "underline", textAlign: "left" }}
        >
          {title}
        </Typography>
        <Typography color="textSecondary" sx={{ textAlign: "left" }}>
          No Records Found
        </Typography>
      </Box>
    );
  }

  const donutData = { labels, datasets };

  const donutOptions = options || {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "bottom" as const },
      tooltip: { enabled: true },
      datalabels: {
        color: "#fff",
        font: { weight: "bold" as const, size: 12 },
        formatter: (value: number) => value.toString(),
      },
    },
    cutout: "60%",
  };

  return (
    <Box
      sx={{
        bgcolor: "#fff",
        borderRadius: 2,
        boxShadow: 1,
        textDecoration: "underline",
      }}
    >
      <Typography sx={{ p: 2 }} fontWeight={600} mb={1}>
        {title}
      </Typography>
      <Box sx={{ height }}>
        <Doughnut data={donutData} options={donutOptions} />
      </Box>
    </Box>
  );
};

export default memo(GenericDonutChart);
